// EmailInput.js
import React from 'react';

const EmailInput = ({ label, name, value, onChange, required }) => {
    return (
        <div className="form-group">
            <label>{label} {required && <span>*</span>}</label>
            <input
                type="email"
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className="form-input"
            />
        </div>
    );
};

export default EmailInput;
